export function videoSlider() {
    let initializedClassName = "initialized";

    $(".video-slider").each(function () {
        let slider = $(this);
        let isRowView = slider.closest(".video-row");

        if (!slider.hasClass(initializedClassName)) {
            let items = slider.find(".video-item");

            if (items.length > 1) {
                slider
                    .addClass(initializedClassName)
                    .slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        variableWidth: true,
                        focusOnSelect: true,
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: isRowView.length ? 3 : 1,
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: isRowView.length ? false : true
                                }
                            }
                        ]
                    });
            }
        }
    });

    const $window = $(window);
    $window.on("load resize", function(){
        const windowWidth = $window.width();

        $(".video-slider").each(function () {
            let slider = $(this);
            let isRowView = slider.closest(".video-row");
            let countSlider = windowWidth >= 1360 ? 4 : 3;

            if (slider.hasClass(initializedClassName) && slider.find(".video-item").length <= countSlider && isRowView && windowWidth >= 1024) {
                slider.addClass("notransform");
            } else {
                slider.removeClass("notransform");
            }
        });
    });
}








// WEBPACK FOOTER //
// ./assets/js/modules/videoSlider.js